import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/common/box.png'
import _imports_1 from '@/assets/common/left_coin.png'
import _imports_2 from '@/assets/common/right_coin.png'


const _hoisted_1 = { class: "main_wrapper" }
const _hoisted_2 = { class: "rewards-wrapper" }
const _hoisted_3 = { class: "main-header" }
const _hoisted_4 = {
  key: 0,
  class: "main-layout"
}
const _hoisted_5 = { class: "featured-content" }
const _hoisted_6 = { class: "featured-amount" }
const _hoisted_7 = { class: "availability-status" }
const _hoisted_8 = { class: "grid-container featured-grid-area" }
const _hoisted_9 = { class: "rewards-grid-4" }
const _hoisted_10 = { class: "day-tag-small" }
const _hoisted_11 = { class: "grid-card-content" }
const _hoisted_12 = { class: "item-date" }
const _hoisted_13 = { class: "item-value" }
const _hoisted_14 = {
  key: 1,
  class: "overflow-section"
}
const _hoisted_15 = {
  class: "grid-container",
  style: {"padding-bottom":"10px"}
}
const _hoisted_16 = { class: "rewards-grid-6" }
const _hoisted_17 = { class: "day-tag-small" }
const _hoisted_18 = { class: "grid-card-content" }
const _hoisted_19 = { class: "item-date" }
const _hoisted_20 = { class: "item-value" }
const _hoisted_21 = { class: "stats-footer" }
const _hoisted_22 = { class: "stats-label" }
const _hoisted_23 = { class: "stats-value-row" }
const _hoisted_24 = { class: "total-amount-text" }
const _hoisted_25 = { class: "stats-sub" }

import { dayFormat, formatCurrency, getDefaultRewards } from '@/utils/commonFunction';
import { computed, PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'cashBackCard',
  props: {
  showClickButton: { type: Boolean, default: true },
  availableValue: { type: Number, default: 0.00 },
  dayList: {
    type: Array as PropType<any[]>,
    default: () => getDefaultRewards() 
  }
},
  emits: ['getClaim'],
  setup(__props, { emit: __emit }) {

const props = __props;
console.log("Day list",props.dayList)
const emits = __emit;
const clickOnButton = () => emits('getClaim');

const hasInitialRewards = computed(() => props.dayList && props.dayList.length > 0);

const featuredList = computed(() => {
  return props.dayList ? props.dayList.slice(1, 9) : [];
});

const overflowList = computed(() => {
  return props.dayList ? props.dayList.slice(9) : [];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('cashback.recompensas')), 1),
      (hasInitialRewards.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(["featured-card", { 'no-button': !__props.showClickButton }])
            }, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "day-tag-large" }, "DIA 1", -1)),
              _createElementVNode("div", _hoisted_5, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "featured-currency" }, "R$", -1)),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(formatCurrency)(__props.dayList[0].amount)), 1),
                (__props.showClickButton)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "action-button",
                      onClick: clickOnButton
                    }, _toDisplayString(_ctx.$t('cashback.conquistar')), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, [
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "check-circle" }, "✓", -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('cashback.disponivel')), 1)
                ])
              ])
            ], 2),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(featuredList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "grid-card"
                  }, [
                    _createElementVNode("div", _hoisted_10, "DIA " + _toDisplayString(index + 2), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _cache[3] || (_cache[3] = _createElementVNode("img", {
                        src: _imports_0,
                        class: "chest-img",
                        alt: "Chest"
                      }, null, -1)),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(dayFormat)(item.date, 0)), 1),
                      _createElementVNode("div", _hoisted_13, "R$ " + _toDisplayString(_unref(formatCurrency)(item.amount)), 1)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (overflowList.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(overflowList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "grid-card"
                  }, [
                    _createElementVNode("div", _hoisted_17, "DIA " + _toDisplayString(index + 10), 1),
                    _createElementVNode("div", _hoisted_18, [
                      _cache[4] || (_cache[4] = _createElementVNode("img", {
                        src: _imports_0,
                        class: "chest-img",
                        alt: "Chest"
                      }, null, -1)),
                      _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(dayFormat)(item.date, 0)), 1),
                      _createElementVNode("div", _hoisted_20, "R$ " + _toDisplayString(_unref(formatCurrency)(item.amount)), 1)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('cashback.ganhos')), 1),
        _createElementVNode("div", _hoisted_23, [
          _cache[5] || (_cache[5] = _createElementVNode("img", {
            src: _imports_1,
            class: "coin-stack",
            alt: "Coins"
          }, null, -1)),
          _createElementVNode("span", _hoisted_24, "R$ " + _toDisplayString(_unref(formatCurrency)(__props.availableValue)), 1),
          _cache[6] || (_cache[6] = _createElementVNode("img", {
            src: _imports_2,
            class: "coin-stack",
            alt: "Coins"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('cashback.totalBonus')), 1)
      ])
    ])
  ]))
}
}

})